import { InputAdornment } from '@mui/material';
import type { FieldValues } from 'react-hook-form';

import { TextField, type TextFieldProps } from './TextField';

export type PhoneFieldProps<T extends FieldValues> = Omit<TextFieldProps<T>, 'type' | 'slotProps'>;

/** An Indian mobile number input with a fixed +91 prefix. */
export function PhoneField<T extends FieldValues>(props: PhoneFieldProps<T>) {
  return (
    <TextField
      {...props}
      type="tel"
      slotProps={{
        htmlInput: { inputMode: 'tel', maxLength: 10 },
        input: {
          startAdornment: <InputAdornment position="start">+91</InputAdornment>,
        },
      }}
    />
  );
}
